import { createAction, createSlice } from "@reduxjs/toolkit";
import { CaseComparison } from "../model/calculations/calculation";

interface State {
    isComparison: boolean;
    comparisonData1: CaseComparison | null;
    comparisonData2: CaseComparison | null;
    comparisonData3: CaseComparison | null;
    compareInput1: string;
    compareInput2: string;
    compareInput3: string;
    persistedCase1: string;
    persistedCase2: string;
    persistedCase3: string;
    case1SystemTDH: number | null;
    case2SystemTDH: number | null;
    case3SystemTDH: number | null;
}

export const initialState: State = {
    isComparison: false,
    comparisonData1: null,
    comparisonData2: null,
    comparisonData3: null,
    persistedCase1: "",
    persistedCase2: "",
    persistedCase3: "",
    compareInput1: "",
    compareInput2: "",
    compareInput3: "",
    case1SystemTDH: null,
    case2SystemTDH: null,
    case3SystemTDH: null
};

export const getComparisonData = createAction("Comparison/getComparisonData");

const ComparisonSlice = createSlice({
    name: 'Comparison',
    initialState,
    reducers: {
        setIsComparison(state, action) {
            state.isComparison = action.payload;
        },
        setComparisonData1(state, action) {
            state.comparisonData1 = action.payload;
        },
        setComparisonData2: (state, action) => {
            state.comparisonData2 = action.payload;
        },
        setComparisonData3: (state, action) => {
            state.comparisonData3 = action.payload;
        },
        setComparisonInput1(state, action) {
            state.compareInput1 = action.payload !== "00000000-0000-0000-0000-000000000000" ? action.payload : state.compareInput1;
        },
        setComparisonInput2: (state, action) => {
            state.compareInput2 = action.payload;
        },
        setComparisonInput3: (state, action) => {
            state.compareInput3 = action.payload;
        },
        setPersistedCase1(state, action) {
            state.persistedCase1 = action.payload;
        },
        setPersistedCase2: (state, action) => {
            state.persistedCase2 = action.payload;
        },
        setPersistedCase3: (state, action) => {
            state.persistedCase3 = action.payload;
        },
        setCase1SystemTDH: (state, action) => {
            state.case1SystemTDH = action?.payload;
        },
        setCase2SystemTDH: (state, action) => {
            state.case2SystemTDH = action?.payload;
        },
        setCase3SystemTDH: (state, action) => {
            state.case3SystemTDH = action?.payload;
        },
    }
});

export const {
    setIsComparison,
    setComparisonData1,
    setComparisonData2,
    setComparisonData3,
    setComparisonInput1,
    setComparisonInput2,
    setComparisonInput3,
    setPersistedCase1,
    setPersistedCase2,
    setPersistedCase3,
    setCase1SystemTDH,
    setCase2SystemTDH,
    setCase3SystemTDH
} = ComparisonSlice?.actions;

export default ComparisonSlice.reducer;